import { createClient, type SanityClient } from "@sanity/client";
import imageUrlBuilder from "@sanity/image-url";

export const sanityClient: SanityClient = createClient({
  projectId: "uexbhi59",
  dataset: "production",
  apiVersion: "2024-01-01",
  useCdn: true,
});

type SanityImageSource = Parameters<ReturnType<typeof imageUrlBuilder>["image"]>[0];
const builder = imageUrlBuilder(sanityClient);
export const urlFor = (source: SanityImageSource) => builder.image(source);

type SanityImageWithAsset = {
  asset: { url: string; metadata?: { dimensions?: { width: number; height: number } } };
};

export type CaseStudy = {
  _id: string;
  _createdAt?: string;
  _updatedAt?: string;
  title: string;
  excerpt: string;
  category?: string;
  company?: string;
  metric?: string;
  externalUrl?: string;
  slug?: { current: string };
  coverImage?: SanityImageSource;
  // Portable Text body
  body?: any;
  // SEO fields
  meta_title?: string;
  meta_description?: string;
  keywords?: string[];
  canonical_url?: string;
  // Open Graph fields
  og_title?: string;
  og_description?: string;
  og_type?: "article" | "website";
  og_image?: SanityImageWithAsset;
  // Twitter fields
  twitter_title?: string;
  twitter_description?: string;
  twitter_card_type?: "summary" | "summary_large_image" | "player" | "app";
};

export type BlogPost = {
  _id: string;
  _createdAt?: string;
  _updatedAt?: string;
  title: string;
  excerpt: string;
  category?: string;
  author?: string;
  readTime?: string;
  publishedAt?: string;
  externalUrl?: string;
  slug?: { current: string };
  coverImage?: SanityImageSource;
  // Portable Text body
  body?: any;
  // SEO fields
  meta_title?: string;
  meta_description?: string;
  keywords?: string[];
  canonical_url?: string;
  // Open Graph fields
  og_title?: string;
  og_description?: string;
  og_type?: "article" | "website";
  og_image?: SanityImageWithAsset;
  // Twitter fields
  twitter_title?: string;
  twitter_description?: string;
  twitter_card_type?: "summary" | "summary_large_image" | "player" | "app";
  // Editorial FAQ — rendered on the post and emitted as FAQPage JSON-LD.
  // Only fetched on the single-post query, never on the listing projections.
  faq?: { question: string; answer: string }[];
};

export type GeoResource = {
  _id: string;
  _updatedAt?: string;
  title: string;
  excerpt: string;
  category?: string;
  readTime?: string;
  publishedAt?: string;
  externalUrl?: string;
  slug?: { current: string };
  coverImage?: SanityImageSource;
};
